import {useEffect, useState} from 'react';
import { makeStyles } from '@material-ui/core';
import { useHistory } from "react-router";

import { Typography,Grid } from '@material-ui/core';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import IconButton from '@material-ui/core/IconButton';
import ImageIcon from '@material-ui/icons/Image';


const useStyles = makeStyles(() => ({
    root: {
      flex: '1 1 auto',
      height: '100%',
      overflowX: 'hidden',
      background: '#F0F0F0',
      paddingTop: 37,
    },
    loadingDiv: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100%'
    },
    paddingHorizontal: {
      padding: '0 20px',
    },
    pdfMargin: {
      marginTop: (props: any) => props ? 50 : 10,
    },
    foo: {},
    maingrid: {
        marginTop: '50px',
        width: '90%',
    },
    mainSection: {
      padding: '0 40px 150px 0',
      flex: 1,
      flexDirection: 'column',
      display: 'flex',
      position: 'relative',
      margin: "20px",
      '@media (min-width: 2000px)': {
        width: 1200
      },
      '@media (max-width: 1150px)': {
        padding: '0 0 150px 0',
      },
      '@media (max-width: 600px)': {
        padding: '0',
        marginTop: 40
      },
    },
    center: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: '100%',
      height: '100%'
    }
  }));



  export default function KnownOverview(props: any) {
    const [sessionCode, setSessionCode] = useState(props.match.params.session_code);
    const queryStringOverview = new URLSearchParams(props.history.location.search).get("overview")
    const history = useHistory();
    const classes = useStyles(false);
    
    useEffect(() => {
        history.push(window.location.pathname)
      }, [queryStringOverview]);
    
      useEffect(() => {
        const state = props.history.location.state;
        if (state) {
          if (state.session_id && state.session_id !== undefined) {
            localStorage.setItem('session_id', state.session_id);
          }
        }
      }, [props.history.location]);
    
      useEffect(() => {
        const session_code = props.match.params.session_code;
        setSessionCode(session_code);
        if (session_code)
          localStorage.setItem('session_code', session_code);
      }, [props.match.params.session_code]);
    

    return (
        <>
        
        <Grid container spacing={3} direction={'column'} alignContent={'center'} id="KnownResultsHolder">
        <Grid container spacing={3} direction={'row'} alignContent={'center'} id="KnownResultsOverview" className={classes.maingrid}>
       
            <Grid item xs={12} sm={12} >
                <Typography variant="h5">known overview page: {sessionCode}</Typography>

                <Card className={classes.foo}>
                    <CardHeader title="Results Overview" style={{background: '#6667ab', color: '#f2f2fa'}}/>
                    <CardContent  style={{background: '#f2f2fa'}}>
                        <Typography variant="body2" color="textSecondary" component="p">
                        This impressive paella is a perfect party dish and a fun meal to cook together with your
                        guests. Add 1 cup of frozen peas along with the mussels, if you like.
                        </Typography>
                    </CardContent>
                </Card>
            </Grid>
        
            <Grid item xs={12} md={6}>
                <Card className={classes.foo}>
                    <CardHeader title="Best Moments" style={{background: '#6667ab', color: '#f2f2fa'}} action={
                        <IconButton aria-label="settings">
                            <ImageIcon style={{color: '#f2f2fa'}} />
                        </IconButton>
                        }/>
                    <CardContent>
                        <Typography variant="body2" color="textSecondary" component="p">
                        This impressive paella is a perfect party dish and a fun meal to cook together with your
                        guests. Add 1 cup of frozen peas along with the mussels, if you like.
                        </Typography>
                    </CardContent>
                </Card>
            </Grid>

            <Grid item xs={12} md={6}>
                <Card className={classes.foo}>
                    <CardHeader title="Worst Moments" style={{background: '#6667ab'}}/>
                    <CardContent>
                        <Typography variant="body2" color="textSecondary" component="p">
                        This impressive paella is a perfect party dish and a fun meal to cook together with your
                        guests. Add 1 cup of frozen peas along with the mussels, if you like.
                        </Typography>
                    </CardContent>
                </Card>
            </Grid>


            <Grid item xs={12} md={12}>
                <Card className={classes.foo}>
                    <CardHeader title="Audience Breakdown" style={{background: '#6667ab'}}/>
                    <CardContent>
                        <Typography variant="body2" color="textSecondary" component="p">
                        This impressive paella is a perfect party dish and a fun meal to cook together with your
                        guests. Add 1 cup of frozen peas along with the mussels, if you like.
                        </Typography>
                    </CardContent>
                </Card>
            </Grid>


            <Grid item xs={12} md={6}>
                <Card className={classes.foo}>
                    <CardHeader title="High Immersion Groups" style={{background: '#6667ab'}}/>
                    <CardContent>
                        <Typography variant="body2" color="textSecondary" component="p">
                        This impressive paella is a perfect party dish and a fun meal to cook together with your
                        guests. Add 1 cup of frozen peas along with the mussels, if you like.
                        </Typography>
                    </CardContent>
                </Card>
            </Grid>

            <Grid item xs={12} md={6}>
                <Card className={classes.foo}>
                    <CardHeader title="Low Immersion Groups" style={{background: '#6667ab'}}/>
                    <CardContent>
                        <Typography variant="body2" color="textSecondary" component="p">
                        This impressive paella is a perfect party dish and a fun meal to cook together with your
                        guests. Add 1 cup of frozen peas along with the mussels, if you like.
                        </Typography>
                    </CardContent>
                </Card>
            </Grid>


        </Grid>
        </Grid>


       


        <div className={classes.foo}></div>
        </>
    )
  }